import { Component, OnInit, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { marked } from 'marked';
import { ButtonComponent } from '../../../components/button/button.component';
import { AuthService } from '../../../state/auth/auth.service';
import { ModalService } from '../../../state/modal/modal.service';
import { BackendService } from '../../../api/bff/backend.service';
import { eulaVersion } from '@shared/utils/eulaVersion';
import { firstValueFrom, map, Observable } from 'rxjs';

@Component({
  selector: 'app-eula-view',
  imports: [ButtonComponent, AsyncPipe],
  templateUrl: './eula-view.component.html',
  styleUrl: './eula-view.component.css',
})
export class EulaViewComponent implements OnInit {
  private http = inject(HttpClient);
  private authService = inject(AuthService);
  private modalService = inject(ModalService);
  private backend = inject(BackendService);

  public signupFlow = true;
  protected eula$!: Observable<string>;

  ngOnInit(): void {
    this.eula$ = this.loadEulaText();
  }

  loadEulaText(): Observable<string> {
    return this.http
      .get('eula/v2(2025-02-11_AGCO_SOLUTIONS_EULA).md', { responseType: 'text' })
      .pipe(map((data) => marked(data) as string));
  }

  async acceptEula() {
    if (this.signupFlow) {
      this.authService.signUp();
    } else {
      const user = await this.authService.user;
      if (!user) throw new Error('User not found');
      await firstValueFrom(this.backend.putUser({ ...user, eulaVersion }));
      this.modalService.closeModal();
    }
  }
}
